import {Color, Vector3, Vector4} from 'three'

type UniformValue<T> = {value: T}

export const commonUniforms = {
  uColor1: {value: new Color(0x096bde)} as UniformValue<Color>,
  uColor2: {value: new Color(0x140fff)} as UniformValue<Color>,
  uColor3: {value: new Color(0x000aff)} as UniformValue<Color>,
  uColor4: {value: new Color(0x6bd6d0)} as UniformValue<Color>,
  uLightColor: {value: new Color(0xf0f7ff)} as UniformValue<Color>,
  uTime: {value: 0} as UniformValue<number>,
  uBgColor: {value: new Color(0x0d1117)} as UniformValue<Color>,
  uColorMap: {value: new Vector4(0.4, 0.7, 0.8, 0.95)} as UniformValue<Vector4>,
  uLightPos: {value: new Vector3(0, 0, 1.5)} as UniformValue<Vector3>,
  uLightIntensity: {value: 0.0} as UniformValue<number>,
  uBeatSpeed: {value: 0.25} as UniformValue<number>,
}
